import {useState,useEffect} from 'react';
import {readStorage,writeStorage} from '../utils/storage.js';
const KEY='og:display-preferences';
function load(){try{const d=JSON.parse(readStorage(KEY)||'{}');return {text:d.text==='large'?'large':'standard'};}catch{return {text:'standard'};}}
export function useDisplayPreferences(){const [value,setValue]=useState(load);useEffect(()=>{document.documentElement.dataset.textSize=value.text;writeStorage(KEY,JSON.stringify(value));},[value]);return [value,setValue];}
